var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaselineSearch24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2195",
    d: "M32 0H0v32h32z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Search",
    d: "M24.82 25.859l-.083-.07-3.128-3.05a9.7 9.7 0 01-6 2.06A9.518 9.518 0 016 15.4 9.518 9.518 0 0115.611 6a9.518 9.518 0 019.612 9.4 9.25 9.25 0 01-2.531 6.349l3.091 3.014a.713.713 0 010 1.024.753.753 0 01-.964.071zM7.48 15.4a8.052 8.052 0 008.131 7.952 8.052 8.052 0 008.132-7.952 8.052 8.052 0 00-8.132-7.952A8.052 8.052 0 007.48 15.4z",
    fill: "currentColor"
  }))));
}
export default SvgBaselineSearch24Px;